<template>
  <div>
    <div class="mb-4">
      <h6 class="text-base inline-block">Line Items</h6>
      &nbsp;
      <a role="button" class="inline-block" @click="addLine"> Add Line </a>
    </div>
    <div class="grid gap-y-1">
      <PaymentLineHeaderItem />

      <PaymentLineItem
        v-for="(lineItem, idx) in paymentLines"
        :key="`line_item_${idx}`"
        :num="idx"
        :description.sync="lineItem.description"
        :amount.sync="lineItem.amount"
        :disabled="disabled"
        @invoice-line-item:remove="removeLine(idx)"
      />

      <PaymentLineFooterItem :line-items="paymentLines" />
    </div>
  </div>
</template>

<script>
import PaymentLineItemVue from './PaymentLineItem.vue';
import PaymentLineHeaderItemVue from './PaymentLineHeaderItem.vue';
import PaymentLineFooterItemVue from './PaymentLineFooterItem.vue';

const DEFAULT_LINE_ITEM = {
  description: 'Πληρωμή',
  amount: 0,
};
export default {
  components: {
    PaymentLineHeaderItem: PaymentLineHeaderItemVue,
    PaymentLineItem: PaymentLineItemVue,
    PaymentLineFooterItem: PaymentLineFooterItemVue,
  },

  props: {
    paymentLines: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
  },

  data() {
    return {
      data: [
        //
      ],
    };
  },

  methods: {
    addLine() {
      this.$emit('update:payment-lines', [...this.paymentLines, { ...DEFAULT_LINE_ITEM }]);
    },
    removeLine(removedIndex) {
      this.$emit('update:payment-lines', [
        ...this.paymentLines.filter((line, index) => index !== removedIndex),
      ]);
    },
  },
};
</script>
